<template>
  <ControlWrapper
    v-bind="control.controlWrapper.value"
    :styles="control.styles"
    :is-focused="control.isFocused.value"
    :applied-options="control.appliedOptions.value"
    :error="control.control.value.errors"
  >
    <SectionWrapper id="almost-there" class="widget-base-checkbox">
      <template #header>
        <h3 :class="control.styles.control.label">
          {{ control.computedLabel }}
        </h3>
      </template>
      <fieldset>
        <legend class="sr-only">{{ control.computedLabel }}</legend>
        <div
          class="widget-base-checkbox_wrapper"
          :data-error="!!control.control.value.errors"
          :class="componentStyles?.checkbox"
        >
          <div class="widget-base-checkbox_checkbox">
            <div class="flex h-6 items-center">
              <WInput
                v-model="isChecked"
                name="checkboxcontrol"
                :id="control.control.value.id + '-input'"
                type="checkbox"
                :disabled="!control.control.value.enabled"
                :autofocus="control.appliedOptions.value.focus"
                :placeholder="control.appliedOptions.value.placeholder"
                class="widget-base-checkbox_input"
                @update:modelValue="onChange"
                @keydown.enter="((isChecked = !isChecked), onChange(isChecked))"
              />
            </div>
            <div class="ml-3 cursor-pointer text-sm leading-6" @click="() => onChange(!isChecked)">
              <label for="checkboxcontrol" class="widget-base-checkbox_label cursor-pointer" v-html="description">
              </label>
            </div>
          </div>
        </div>
      </fieldset>
    </SectionWrapper>
  </ControlWrapper>
</template>

<script setup lang="ts">
  import { ControlElement } from '@jsonforms/core';
  import { ref, watch } from 'vue';
  import { rendererProps, useJsonFormsControl } from '@jsonforms/vue';
  import { useWidgetControl } from '../util';
  import SectionWrapper from 'components/claims-widget/components/SectionWrapper.vue';
  import ControlWrapper from './ControlWrapper.vue';
  import WInput from '../../base/Input.vue';
  import { config, getComponentStyle } from 'src/utils/config';

  const props = defineProps(rendererProps<ControlElement>());
  const componentStyles = getComponentStyle();
  const control = useWidgetControl(useJsonFormsControl(props));
  const isChecked = ref((control.control.value.data || false) as boolean);
  const description = ref(control.control.value.description);
  function onChange(val: boolean | string) {
    isChecked.value = Boolean(val);
    control.onChange(isChecked.value);
  }

  watch(
    () => config.value?.privacyPolicyUrl,
    () => {
      if (config.value?.privacyPolicyUrl) {
        description.value = description.value.replace('#privacy', config.value?.privacyPolicyUrl);
      }
      description.value = description.value.replaceAll('#clientname', config.value.name);
    },
    { immediate: true }
  );
</script>
